import { render } from "./index.vue?vue&type=template&id=282a9a5c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=282a9a5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-282a9a5c"

export default script